<template>
   <div>
     <div class="a-container-form admin-buy__block">
       <div class="a-label a-label--w-280"></div>
       <div class="a-width-100-percent a-flex-start-nowrap" >
         <button class="gui-btn gui-btn--red u-margin-right-20"
                 v-for="(item, idx) in criteria"
                 @click.prevent="onVariableClick(item)">
           {{item.alias}}
         </button>
       </div>
     </div>

     <div class="a-container-form admin-buy__block a-mandatory" :class="{ 'a-input-group--error': $v.formula.$anyError }">
       <div class="a-label a-label--w-280">{{$t('form.tender.reduction.present-price-formula')}}:</div>
       <div class="a-width-100-percent">
         <input type="text"
                ref="formulaInput"
                class="a-input a-input--w-max"
                placeholder="Формула"
                v-model="formula"
                @blur="onFormulaChange">
         <div class="a-text-small">
           {{$t('form.tender.reduction.formula-may-contain')}}
         </div>
       </div>
     </div>

     <div class="a-tab__title-block admin__a-tab">
       <h3>{{$t('form.tender.reduction.fill-values-to-check-formula')}}:</h3>
     </div>

     <div class="a-container-form admin-buy__block" v-for="(item, itemId) in criteria">
       <div class="a-label a-label--w-280">{{item.name}} ({{item.alias}})</div>

       <template v-if="item.format == enums.ProposalFormat.NUMBER">
         <div class="a-input-and-text-block u-margin-right-0">
           <input-cost class="a-input a-input--w-280" placeholder="Значение" v-model="item.value"></input-cost>
           <p>{{$t('form.tender.reduction.number-value', {value: item.name})}}</p>
         </div>
       </template>
       <template v-else-if="item.format == enums.ProposalFormat.CHOICE">
         <div class="a-input-and-text-block u-margin-right-0">
           <dropdown-new class="select-w-280"
                         :placeholder="'Не выбран'"
                         :options="item.values.map(e => ({ id: e.value, name: `${e.name} - ${$options.filters.price(e.value)}`}))"
                         v-model="item.value">
             <option value :label="'form.tender.reduction.item-not-specified'"></option>
           </dropdown-new>
           <p>{{$t('form.tender.reduction.choice-value', {value: item.name})}}</p>
         </div>
       </template>
     </div>

     <div class="a-container-form admin-buy__block">
       <div class="a-label a-label--w-280"></div>
       <button class="gui-btn gui-btn--white-border gui-btn--w-230" @click.prevent="onCalculateClick">{{$t('buttons.check-formula')}}</button>
     </div>

     <div class="a-container-form admin-buy__block">
       <div class="a-label a-label--w-280 u-red-color">{{$t('form.tender.reduction.formula-evaluation-result')}}</div>
       <p class="a-input a-input--disabled" v-if="result !== undefined">{{result}}</p>
       <div class="a-label a-label--auto u-red-color" v-if="error">{{$t('form.tender.reduction.failed-formula-evaluation')}}</div>
     </div>
   </div>
</template>

<script>
  import { evaluate } from 'mathjs'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      criteria: [],
      formula: undefined,
      result: undefined,
      error: undefined
    }),

    created() {
      this.formula = this.tender.formula;

      this.criteria = this.tender.criteria.price.map((e, id) => ({
        alias: `K${id + 1}`,
        name: e.criterionName,
        value: undefined,
        format: e.format,
        values: e.values
      }));

      this.$v.$touch();
    },

    watch: {
      'tender.formula'() {
        this.formula = this.tender.formula;
      },

      'tender.criteria.price'() {
        this.criteria = this.tender.criteria.price.map((e, id) => ({
          alias: `K${id + 1}`,
          name: e.criterionName,
          value: undefined,
          format: e.format,
          values: e.values
        }));
      }
    },

    validations: {
      formula: {
        valid: function(formula, v) {
          return !!formula && !!formula.match(/[0-9K\*-=\/\+]+/);
        },

        evaluated: function(formula,  v) {
          const variables = {};

          for (let c of v.criteria) {
            variables[c.alias.toLowerCase()] = 1;
          }

          try {
            v._evaluateFormula(formula, variables);
            return true;
          }
          catch(e) {
            return false;
          }
        }
      }
    },

    computed: {
      tender() {
        return this.value;
      }
    },

    methods: {
      onVariableClick(item) {
        const cursorPosition = this.$refs.formulaInput.selectionStart;
        const currentValue = this.$refs.formulaInput.value;

        const formula = currentValue.slice(0, cursorPosition) + item.alias + currentValue.slice(cursorPosition + 1);
        this.formula = formula;
        //this.$refs.formulaInput.value = formula;
      },

      _evaluateFormula(formula, variables) {
        let result;

        try {
          result = evaluate(formula.toLowerCase(), variables);
        }
        catch(e) {
          //console.error('unable to evaluate formula', e);
          throw e;
        }

        return result;
      },

      _updateFormula(formula) {
        this.tender.formula = formula;
        this.$emit('input', this.tender);
      },

      onFormulaChange($event) {
        this.$v.$touch();
        if (this.$v.formula.$anyError) return;

        this._updateFormula(this.formula);
      },

      onCalculateClick() {
        this.result = undefined;
        this.error = undefined;

        if (this.$v.formula.$anyError) {
          this.error = 'invalid formula';
          return;
        }

        const variables = {};

        try {
          for (let c of this.criteria) {
            variables[c.alias.toLowerCase()] = +c.value / 100;
          }

          this.result = this._evaluateFormula(this.formula, variables);
        }
        catch(e) {
          console.error('unable to evaluate formula');
          this.error = 'evaluation failed'
        }
      }
    }
  }
</script>

<style scoped>

</style>
